export const EXTERNAL_URL = {
  YAPO: 'localhost:3002',
  DEFAULT: 'tramitta.cl'
};